import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  html[data-scheme-name="haval"] {
    .kdxsc-wrapper__inner button,
    button {
      font-family: 'Haval', Roboto, Helvetica Neue, Arial, sans-serif !important;
      font-weight: 500;
    }
    .kdxsc-attention__header {
      font-size: 12px!important;
    }
  }
`
